import React from 'react'
import Helmet from 'react-helmet'
import HeaderDesktop from '../components/HeaderDesktop'
import HeroDesktop from '../components/HeroDesktop'
import TweetArray from '../components/TweetArray'
import FooterDesktop from '../components/FooterDesktop'

import HeaderPhone from '../components/HeaderPhone'
import HeroPhone from '../components/HeroPhone'
import MiddlePhone from '../components/MiddlePhone'
import FooterPhone from '../components/FooterPhone'

import favicon from '../img/favicon.png';

class IndexPage extends React.Component{
  
  constructor(props) {
    super(props)
    this.state = {
      mobileOS:null,
    }
  }


  componentDidMount(){
    const mobileOS=this.getMobileOperatingSystem()
    this.setState({mobileOS:mobileOS})
    if(window.analytics){
      window.analytics.page('Static Site')
    }

  }

  getMobileOperatingSystem() {

  var userAgent = navigator.userAgent || navigator.vendor || window.opera

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone"
    }

    if (/android/i.test(userAgent)) {
        return "Android"
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPhone/.test(userAgent) && !window.MSStream) {
        return "iPhone"
    }

    if (/iPad/.test(userAgent) && !window.MSStream) {
        return "iPad"
    }

    return null
}

  render() {

    const {mobileOS}=this.state
    
    return(      
      <div className='page'>   
        <Helmet
          title={'Plickers'}
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' },
          ]}
          link={[
            { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
          ]}
        />

        <HeaderDesktop mobileOS={mobileOS} />    
        <HeroDesktop mobileOS={mobileOS} />
        <TweetArray />
        <FooterDesktop mobileOS={mobileOS} />

        <HeaderPhone />
        <HeroPhone mobileOS={mobileOS} />
        <MiddlePhone mobileOS={mobileOS} />
        <FooterPhone />
        
      </div>
    )
  }
}

export default IndexPage
